import { isInternalLink } from "@/utils/links";
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default function useAlert() {
  const store = useStore();
  const router = useRouter();
  const alertModel = computed(() => store.getters["system/getAlertModel"]);

  function onAlertHide() {
    if (alertModel.value.onHide) {
      alertModel.value.onHide();
    }
    store.dispatch("system/hideAlert");
  }

  function openLink() {
    const redirect = (dest) => {
      if (isInternalLink(dest)) {
        router.push(dest);
      } else {
        window.location = dest;
      }
    };

    const link = alertModel.value.buttonLink;
    if (typeof link === "function") {
      link(redirect);
      return;
    }

    redirect(link);
  }
  return {
    alertModel,
    openLink,
    onAlertHide,
  };
}
